export const getCarrierGridColumnsColumns = (carrier_GridHeaders, isEnableProvider, sharedSmallParcelSettings, dynamicCarrierAccountSchema) => {
    return ({
        columns: [{
            field: "RowNumber",
            title: "#",
            hidden: true,
            menu: false,
            width: "100%"
        }, {
            field: "Owner",
            title: carrier_GridHeaders[0].description,
            width: 300,
            wmsid: 1
        }, {
            field: "RateShop",
            title: carrier_GridHeaders[6].description,
            width: 120,
            wmsid: 6,
            hidden: sharedSmallParcelSettings.SmallParcelCarrierSelectionV2 ? false : true,
            template: function (dataItem) {
                let rateshop = "";
                if(sharedSmallParcelSettings.SmallParcelRateShoppingCarrierAccounts) {
                    let selectedCarrierAccounts = sharedSmallParcelSettings.SmallParcelRateShoppingCarrierAccounts.split(",");
                    if(selectedCarrierAccounts.indexOf(dataItem.AccountNumber) !== -1) {
                        rateshop = "Yes";
                    }
                }
                return rateshop;
            }
        }, {
            field: "IncludeShippingCost",
            title: carrier_GridHeaders[7].description,
            width: 220,
            wmsid: 7,
            template: function (dataItem) {
                let includeShippingCost = "No";
                if(dataItem.IncludeShippingCost) {
                    includeShippingCost = "Yes";
                }
                return includeShippingCost;
            }
        }, {
            field: "Carrier",
            title: carrier_GridHeaders[1].description,
            width: 160,
            wmsid: 2,
            template: function (dataItem) {
                let carrier = dataItem.Carrier;
                if (isEnableProvider) {
                    if (carrier == "Stamps.com" || carrier == "Endicia") {
                        carrier = "USPS - " + carrier;
                    } else if (carrier == "Buku" && dataItem.Provider == "bukuShip") {
                        carrier = "USPS - BUKU Ship";
                    } else if (carrier == "PitneyBowesExp") {
                        carrier = "USPS - Pitney Bowes Expedited";
                    } else if (carrier == "PitneyBowesStd") {
                        carrier = "Pitney Bowes Standard";
                    }
                }
                return carrier;
            }
        }, {
            field: "Provider",
            title: carrier_GridHeaders[2].description,
            width: 160,
            wmsid: 3,
            hidden : isEnableProvider ? false : true,
            template: function (dataItem) {
                return dynamicCarrierAccountSchema[`${dataItem.Provider}`]?.name || "";
            }
        }, {
            field: "NickName",
            title: carrier_GridHeaders[3].description,
            width: 255,
            filterable: true,
            wmsid: 4
        }, {
            field: "Type",
            title: carrier_GridHeaders[4].description,
            width: 155,
            wmsid: 5
        }, {
            field: "AccountNumber",
            title: carrier_GridHeaders[5].description,
            width: 185,
            wmsid: 6
        }]
    });
};

export const getCarrierGridSchema = () => {
    return ({
        schema: {
            data: "Data",
            total: "Total",
            model: {
                id: "Owner",
                fields: {
                    RowNumber: {
                        type: 'number'
                    },
                    facility: {
                        type: "string",
                        editable: false
                    },
                    rateshop: {
                        type: "string",
                        editable: false
                    },
                    includeShippingCost: {
                        type: "string",
                        editable: false
                    },
                    carrier: {
                        type: "string",
                        editable: false
                    },
                    provider: {
                        type: "string",
                        editable: false
                    },
                    accnickname: {
                        type: "string",
                        editable: false
                    },
                    acctype: {
                        type: "string",
                        editable: false
                    }
                }
            }
        }
    });
};

export const getCarrierAccountListColumn = () => {
    return ([
        {
            selectable: true,
            width: 20,
            // eslint-disable-next-line sonarjs/no-duplicate-string
            attributes: { class: "k-text-center" },
            headerAttributes: { class: "k-text-center" },
        },
        {
            field: "nickname",
            title: "Account Nickname",
            width: 120,
            wmsid: 1,
            filterable: true,
        },
        {
            field: "carrier",
            title: "Carrier",
            width: 120,
            wmsid: 2,
            filterable: true,
        },
        {
            field: "accountNumber",
            title: "Account Number",
            width: 120,
            wmsid: 3,
            filterable: true,
        },
    ])
};

export const getCarrierAccountListSchema = () => {
    return ({
        data: "Data",
        total: "Total",
        model: {
            id: "Id",
            fields: {
                carrierId: {
                    type: "string",
                    editable: false,
                },
                nickname: {
                    type: "string",
                    editable: true,
                },
                carrier: {
                    type: "string",
                    editable: false,
                },
                accountNumber: {
                    type: "string",
                    editable: false,
                },
            },
        },
    })
};

